export function uniqueBy<T>(items: T[], selector: (item: T) => unknown): T[] {
  const map = new Map<unknown, T>();
  for (const item of items) {
    map.set(selector(item), item);
  }
  return [...map.values()];
}

export function setsIntersect(a: Set<unknown>, b: Set<unknown>) {
  const [small, large] = a.size <= b.size ? [a, b] : [b, a];
  for (const item of small) {
    if (large.has(item)) return true;
  }
  return false;
}

export function partitionArray<T>(items: T[], predicate: (item: T) => boolean): [T[], T[]] {
  const truthy: T[] = [];
  const falsy: T[] = [];

  for (const item of items) {
    if (predicate(item)) {
      truthy.push(item);
    } else {
      falsy.push(item);
    }
  }

  return [truthy, falsy];
}
